import script from "./Testing_Inputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Testing_Inputs.vue?vue&type=script&setup=true&lang=ts"

import "./Testing_Inputs.vue?vue&type=style&index=0&id=7f8fcb10&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8fcb10"]])

export default __exports__